import Typography from '@mui/material/Typography';
import { Box, Stack } from '@mui/material';
import sectionConstants from '../../constants/SectionConstants';
import './Section1.scss';

export const Section1 = () => {
  return (
    <Box className={`content`}>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.PrivacyPolicy}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={4} mt={4}>
          {sectionConstants.PrivacyPolicy1}
        </Box>
        <Box mb={4}>{sectionConstants.PrivacyPolicy2}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.WhatWeDo0}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={3} mt={4}>
          {sectionConstants.WhatWeDo1}
        </Box>
        <Box mb={3}>{sectionConstants.WhatWeDo2}</Box>
        <Box mb={3}>{sectionConstants.WhatWeDo3}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.Constent}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mt={4} mb={3}>
          {sectionConstants.Constent1}
        </Box>
        <Box mb={2}>{sectionConstants.Constent2}</Box>
        <Box mb={2}>{sectionConstants.Constent3} </Box>
        <Box mb={2}>{sectionConstants.Constent4}</Box>
        <Box mb={4}>{sectionConstants.Constent5}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.DisClosure}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mt={4} mb={3}>
          {sectionConstants.DisClosure1}
        </Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.ThirdPartyServices}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={4}>
          {sectionConstants.ThirdPartyServices1}
        </Box>
        <Box mb={2}>{sectionConstants.ThirdPartyServices2}</Box>
        <Box mb={2}>{sectionConstants.ThirdPartyServices3}</Box>
        <Box mb={2}>{sectionConstants.ThirdPartyServices4}</Box>
        <Box mb={2}>{sectionConstants.ThirdPartyServices5}</Box>
        <Box mb={2}>{sectionConstants.ThirdPartyServices6}</Box>
        <Box mb={4}>{sectionConstants.ThirdPartyServices7}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.Security}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={4}>
          {sectionConstants.Security1}
        </Box>
        <Box mb={4}>{sectionConstants.Security2}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.AgeOfConstent}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={4} mt={3}>
          {sectionConstants.AgeOfConstent1}
        </Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.ChangeToThis}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={3} mt={3}>
          {sectionConstants.ChangeToThis1}
        </Box>
        <Box mb={3}>{sectionConstants.ChangeToThis2}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.QuestionsAndContact}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={3} mt={3}>
          {sectionConstants.QuestionsAndContact1}
        </Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.CreditContactInformation}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Stack direction='row' spacing={1} mb={3} mt={3}>
          <Box>{sectionConstants.ThisPrivacyPolicyWasCreated}</Box>
          <Box component='a' href='mailto: contact@datayaan.com'>
            {sectionConstants.Email}
          </Box>
          <Box>{sectionConstants.Or}</Box>
          <Box component='a' href='tel:+914422271400'>
            {sectionConstants.Phone}
          </Box>
        </Stack>
      </Typography>
    </Box>
  );
};
